import { useMemo, useState } from 'react';
import { SEASONAL_COMPARATOR_IMAGE_KEYS } from 'types/Meteorology/Weather/SeasonalComparator/getImages';

const BUTTON_TEXT = {
  firstModelImage: 'Modelo 1',
  secondModelImage: 'Modelo 2',
  differenceImage: 'Diferença',
};

export default function useImageSelection() {
  const [selected, setSelected] = useState('firstModelImage');
  const buttonData = useMemo(() => (SEASONAL_COMPARATOR_IMAGE_KEYS.map((key) => ({
    text: BUTTON_TEXT[key],
    active: key === selected,
    onClick: () => {
      setSelected(key);
    },
  }))), [selected]);

  return {
    buttonData,
    selected,
  };
}
